export default __webpack_public_path__ + "static/media/casaduana_objetivo01.c18cd2f8.jpg";